<script setup lang="ts">
    import { onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';
    import { QuillEditor } from '@vueup/vue-quill'
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: "",
        nom: "",
        description: "",
        bg_color: "",
        image: null as any,
        image_preview: '/assets/users/default.png',
    });
    const errors = reactive({
        nom: "",
        description: "",
        bg_color: "",
        image: null
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        if (form_datas?.categorie) {
            const item = form_datas.categorie as any;
            formData.id = item.id;
            formData.nom = item.nom;
            if (item.image !== undefined) {
                formData.image_preview = item.image_url;
            }
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;

        errors.nom = '';
        if (!formData.nom) {
            errors.nom ="La nom est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = new FormData();
            if (formData.id != null) {
                formToUpload.append("id", `${formData.id}`);
            }
            formToUpload.append("nom", formData.nom);
            formToUpload.append("description", formData.description);
            formToUpload.append("bg_color", formData.bg_color);
            if (formData.image?.file) {
                formToUpload.append("image", formData.image.file, formData.image.name);
            }
            await axios.post(`/backoffice/market-categories/save`, formToUpload);
            router.push('/app/market/market-categories/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    function onFileImageUploaded(uploadedFile: { file: any, file_name: string, file_preview: string }) {
        formData.image_preview = uploadedFile.file_preview;
        formData.image = { file: uploadedFile.file, name: uploadedFile.file_name };
    }
</script>

<template>
    <section class="container-full-1 bg-grey-50">
        <div class="page-space-30"></div>

        <section class="s15_mobile px-4">
            <div class="widget px-7 py-7">
                <h4 class="font-semibold mb-5">Catégories Market / Edition <span class="text-sm text-grey-500"></span></h4>

                <div class="form-field-floating reactive active my-4">
                    <input type="text" class="form-input" v-model="formData.nom" name="nom" id="nom" placeholder="" autocomplete="off">
                    <label for="nom">Libellé <b class="color-danger">*</b></label>
                </div>
                <span v-if="!!errors['nom']" class="text-red">{{ errors['nom'] }}</span>

                <div class="form-field-floating reactive active my-4" style="height: 75px;">
                    <input type="color" class="form-input" v-model="formData.bg_color" name="bg_color" id="bg_color" placeholder="" autocomplete="off" style="height: 75px;">
                    <label for="bg_color">Couleur</label>
                </div>
                <span v-if="!!errors['bg_color']" class="text-red">{{ errors['bg_color'] }}</span>

                <QuillEditor id="description" v-model:content="formData.description" contentType="html" theme="snow" style="height: 300px" />
                <span v-if="!!errors['description']" class="text-red">{{ errors['description'] }}</span>

                <div class="clear-both h-30"></div>
                <span v-if="!!errorMessage" class="text-red">{{ errorMessage }}</span>
                <p class="text-text-xs text-grey-500 mb-5"><b class="color-danger text-xs">*</b> Les champs marqués d'un astérisque sont obligatoires</p>
                <div class="flex gap-2">
                    <custom-button id="btn-submit" type="button" :classesList="'btn lg w-100'" :loading="loading" @click="onSubmit()">
                        <img src="/icons/icon-enregistrer.svg" class="btn-icon" alt="" />
                        <span>Enregistrer</span>
                    </custom-button>
                </div>
                
            </div>
        </section>
        <section class="s5_mobile px-4">
            <div class="widget px-7 py-7">
                <h4 class="font-semibold mb-5 text-center">Image <span class="text-sm text-grey-500"></span></h4>
                <div class="custom-upload-size margin-auto flex mb-8">
                    <custom-upload-input id="photo" label="Photo" type="IMAGE" :preview="formData.image_preview" @uploaded="onFileImageUploaded"></custom-upload-input>
                </div>
            </div>
        </section>
        
    </section>
</template>
